export const DEFAULT_ERROR_MESSAGE = "An unexpected error occurred";
export const NETWORK_ERROR_MESSAGE = "No internet connection. Please check your internet connection and try again.";

export const getErrorFromBackend = (e: unknown): string => {
  const err = e as { response?: { data?: { error?: { message?: string } } }; message?: string };

  // No response means the request never reached the server (offline / DNS failure)
  if (err?.message === "Network Error" && !err?.response) {
    return NETWORK_ERROR_MESSAGE;
  }

  const loopbackError = err?.response?.data?.error?.message || "";
  if (loopbackError) return loopbackError;

  if (e instanceof Error) return e.message;

  return DEFAULT_ERROR_MESSAGE;
};
